import styled from 'styled-components';
import { pureUiTheme } from 'pureUi/pureUiTheme';

const StyledFastSearchContainer = styled.div`
  display: grid;
  grid-template:
    'searchBarWrapper'
    'drawerTrigger'
    'searchResults';
  grid-template-columns: 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  width: 90%;
  max-width: 1280px;
  align-self: center;

  @media (min-width: 1024px) {
    grid-template:
      'backButton .'
      'searchBarWrapper searchBarWrapper'
      'sideBar searchResults';
    grid-template-columns: 0.25fr auto;
  }

  .drawerTrigger {
    grid-area: drawerTrigger;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  .backButton {
    grid-area: backButton;
    display: none;
    align-items: center;
    color: ${pureUiTheme.colors.gold};
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;

    @media (min-width: 1024px) {
      display: flex;
    }

    .backIcon {
      background-color: ${pureUiTheme.colors.grayDark};
      font-size: 16px;
      margin-right: 10px;
    }

    a {
      display: flex;
      align-items: center;
      color: ${pureUiTheme.colors.gold};
    }
  }

  .searchBarWrapper {
    grid-area: searchBarWrapper;
    background-color: white;
    margin-top: 10px;

    input {
      text-transform: none;
      font-size: 14px;
    }

    label > span {
      font-size: 11px;
      letter-spacing: 0.05em;
    }

    .grid {
      column-gap: 15px !important;
    }

    @media (min-width: 1024px) {
      /* SR: destination | dates | rooms | repeat-guest(75px) | button(150px) */
      .grid[class*="124px"] {
        grid-template-columns: 1fr 1fr 1fr 75px 150px !important;
      }

      /* TA with guest country: destination | dates | rooms | guest-country | button(150px) */
      .grid[class*="1fr_1fr_1fr_1fr_215px"] {
        grid-template-columns: 1fr 1fr 1fr 1fr 150px !important;
      }

      /* Basic (no repeat guest, no extra country col): destination | dates | rooms | button(150px) */
      .grid[class*="1fr_1fr_1fr_215px"]:not([class*="1fr_1fr_1fr_1fr"]) {
        grid-template-columns: 1fr 1fr 1fr 150px !important;
      }
    }
  }

  .sideBar {
    grid-area: sideBar;
    min-width: 315px;
    display: none;

    @media (min-width: 1024px) {
      display: block;
    }
  }

  .searchResults {
    grid-area: searchResults;

    &.searchResults--full-width {
      @media (min-width: 1024px) {
        grid-column: 1 / -1;
      }
    }
  }

  input {
    text-transform: uppercase;
    font-size: 14px;
  }

  .searchButton {
    width: 100%;
  }

  .basicSearchLabel {
    text-transform: uppercase;
    font-size: 12px;
    display: block;
    margin-bottom: 1.5rem;
    color: ${pureUiTheme.colorRoles.grayLabel};

    & > span {
      display: block;
      margin-bottom: 10px;
    }
  }

  .repeatGuest {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    margin: 0;

    .label {
      margin-left: 10px;
    }
  }
`;

export default StyledFastSearchContainer;
